import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { components, useServices } from 'cng-web-lib'
import SbciProductMasterApiUrls from '../../../apiUrls/SbciProductMasterApiUrls'
import pathMap from '../../../paths/pathMap'
import ProductMasterLookupsProvider from '../lookups/ProductMasterLookupsContext'
import ProductMasterViewContent from './ProductMasterViewContent'
import AlertDialog from '../../../components/aciacehighway/AlertDialog'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Box,
  Card,
  CardActions,
  CardContent,
  CircularProgress,
  Divider
} from '@material-ui/core'

const {
  button: { CngButton }
} = components

function ViewPage(props) {
  const { history, showNotification } = props
  const { id } = useParams()

  const [data, setData] = useState(null)
  const [confirmDialog, setConfirmDialog] = useState(false)
  const { createRecord, deleteRecord, fetchRecord } = useServices()

  useEffect(() => {
    fetchRecord.execute(SbciProductMasterApiUrls.GET, id, (res) => {
      const data = res.content[0]

      if (data === undefined) {
        showNotification('error', 'Data not found.')
        history.push(pathMap.SBCI_PRODUCT_MASTER_LIST_VIEW)
      } else {
        setData(data)
      }
    })
  }, [])

  if (!data) {
    return <CircularProgress />
  }

  function handleCloneInvoice() {
    if (history.location.state?.cloneData) {
      createRecord.execute(
        SbciProductMasterApiUrls.CLONE,
        history.location.state.cloneData,
        (data) => {
          history.push(pathMap.SBCI_PRODUCT_MASTER_ADD_VIEW, data)
        },
        (error) => {
          console.log(error)
        }
      )
    }
  }

  function handleDeleteInvoice() {
    deleteRecord.execute(
      SbciProductMasterApiUrls.DELETE,
      data,
      () => {
        showNotification('success', 'Delete succeeded')
        history.push(pathMap.SBCI_PRODUCT_MASTER_LIST_VIEW)
      },
      (error) => {
        console.log(error)
      }
    )
  }

  return (
    <>
      <Card>
        <CardContent>
          <ProductMasterLookupsProvider>
            <ProductMasterViewContent
              data={data}
              showNotification={showNotification}
            />
          </ProductMasterLookupsProvider>
        </CardContent>
        <Divider />
        <CardActions style={{ padding: 16, justifyContent: 'space-between' }}>
          <CngButton
            color='secondary'
            onClick={() => history.push(pathMap.SBCI_PRODUCT_MASTER_LIST_VIEW)}
          >
            Back to product master list
          </CngButton>
          <Box display='flex' style={{ gap: 16 }}>
            {(data.status === 'DR' || data.status === 'TP') && (
              <CngButton
                onClick={() => setConfirmDialog(true)}
                startIcon={
                  <FontAwesomeIcon icon={['fal', 'trash']} size='sm' />
                }
                variant='outlined'
              >
                Delete
              </CngButton>
            )}
            <CngButton
              onClick={handleCloneInvoice}
              startIcon={<FontAwesomeIcon icon={['fal', 'copy']} size='sm' />}
              variant='outlined'
            >
              Clone
            </CngButton>
            {data.status !== 'ST' && (
              <CngButton
                color='primary'
                startIcon={<FontAwesomeIcon icon={['fal', 'pen']} size='sm' />}
                onClick={() =>
                  history.push(`${pathMap.SBCI_PRODUCT_MASTER}/edit/${id}`)
                }
              >
                Edit
              </CngButton>
            )}
          </Box>
        </CardActions>
      </Card>
      <AlertDialog
        cancelLabel='No, take me back'
        confirmLabel='Yes, delete'
        open={confirmDialog}
        onClose={() => setConfirmDialog(false)}
        onCancel={() => setConfirmDialog(false)}
        onConfirm={handleDeleteInvoice}
        title='Delete'
      >
        Items that you delete can't be restored. Are you sure about this?
      </AlertDialog>
    </>
  )
}

export default ViewPage
